/*
 * File: input.tsx
 * Project:  @inventures/react-lib
 * File Created: Wednesday, 8th July 2020 11:34:57 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Monday, 24th August 2020 3:58:10 pm
 * Modified By: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
import React from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';

export const Input = (props: TextFieldProps) => <TextField {...props} />;
